import React, { Component } from 'react';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { FiTerminal } from 'react-icons/fi';
import { GrResources } from 'react-icons/gr';
import { 
  DiAndroid,
  DiGit
} from 'react-icons/di';
import { GoBook } from "react-icons/go";
import {
  FaGraduationCap,
  FaJs,
  FaNodeJs,
  FaReact,
  FaJava, 
  FaPython
} from 'react-icons/fa';
import Navbar from '../../components/Navbar';
import AboutCard from '../../components/AboutCard';
import Footer from '../../components/Footer';
import {
  Container,
  Wrapper,
  Main,
  SkillWrapper,
  Skill,
  CaptionWrapper,
  CoursesLink
} from './styles';

export default class About extends Component {
  render() {
    return (
      <>
      <Container>
        <Navbar /> 
        <Wrapper>
          <Main>
            <AboutCard
              icon={<FiTerminal />}
              title="About me"
              content={
                (
                  <>
                  <CoursesLink>
                    <p>
                      My name is Ana Bheatriz, I'm 20 years old, I'm from Natal-RN, Brazil.
                    </p>
                  </CoursesLink>
                  </>
                )
              }
            />
            <AboutCard
              icon={<FaGraduationCap />}
              title="Formation"
              content={
                (
                  <>
                  <CoursesLink>
                    <p>
                        <lu>
                          <li>
                            Complete High School - Dom Marcolino Dantas (2014 - 2016)
                          </li>
                          <li>
                            Systems Analysis and Development - UFRN (2018 - 2021)
                          </li>
                        </lu> 
                      </p>
                  </CoursesLink>
                  </>
                )
              }
            />
            {/* <AboutCard
              icon={<GoBook />}
              title="Courses"
              content={
                (
                  <>
                    <CoursesLink>
                      <p>
                        <lu>
                          <li>
                            <a href=" " target="_blank">
                              Course x
                            </a>
                          </li>
                        </lu> 
                      </p>
                    </CoursesLink>
                  </>
                )
              }
            /> */}
            <AboutCard
              icon={<GrResources />}
              title="Main Skills"
              content={
                (
                  <>
                    <CaptionWrapper>
                      <SkillWrapper>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#a3740d' }}>
                            <FaJava />
                          </IconContext.Provider>
                          <span>Java</span>
                        </Skill>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#3c873a' }}>
                            <DiAndroid />
                          </IconContext.Provider>
                          <span>Android</span>
                        </Skill>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#f1502f' }}>
                            <DiGit />
                          </IconContext.Provider>
                          <span>Git</span>
                        </Skill>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#3c873a' }}>
                            <FaNodeJs />
                          </IconContext.Provider>
                          <span>Node.js</span>
                        </Skill>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#61dbfb' }}>
                            <FaReact />
                          </IconContext.Provider>
                          <span>React</span>
                        </Skill>
                         <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#f0db4f' }}>
                            <FaJs />
                          </IconContext.Provider>
                          <span>Javascript</span>
                        </Skill>
                        <Skill>
                          <IconContext.Provider value={{ size: '64px', color: '#3572A5' }}>
                            <FaPython />
                          </IconContext.Provider>
                          <span>Django</span>
                        </Skill>
                      </SkillWrapper>
                    </CaptionWrapper>
                    <Link to="/skills">SEE MORE</Link>
                  </>
                )
              }
            />
          </Main>
        </Wrapper>
      </Container>
      <Footer/>
      </>
    );
  }
}